import { render } from "./PartnerSdaRemainder.vue?vue&type=template&id=5b3ca17e&scoped=true"
import script from "./PartnerSdaRemainder.vue?vue&type=script&lang=js"
export * from "./PartnerSdaRemainder.vue?vue&type=script&lang=js"

import "./PartnerSdaRemainder.vue?vue&type=style&index=0&id=5b3ca17e&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3ca17e"]])

export default __exports__